import { createRouter, createWebHistory } from 'vue-router'
import Home from './views/Home.vue'
import Dropdown from './views/Dropdown.vue'
import Form from './views/Form.vue'
import Loading from './views/Loading.vue'
import Alert from './views/Alert.vue'
import Modal from './views/Modal.vue'
import Uploader from './views/Upload.vue'
const routerHistory = createWebHistory()
const router = createRouter({
  history: routerHistory,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/dropdown',
      name: 'dropdown',
      component: Dropdown
    },
    {
      path: '/form',
      name: 'form',
      component: Form
    },
    {
      path: '/loading',
      name: 'loading',
      component: Loading
    },
    {
      path: '/alert',
      name: 'alert',
      component: Alert
    },
    {
      path: '/modal',
      name: 'modal',
      component: Modal
    },
    {
      path: '/upload',
      name: 'upload',
      component: Uploader
    }
  ]
})
export default router
